import MasterLayout from './MasterLayout.jsx';

export {MasterLayout}



// WEBPACK FOOTER //
// ./components/layouts/master/index.js